import {useLocation} from 'react-router';

import ErrorContainer from '../components/ErrorContainer';

const NotFoundPage = () => {
  const location = useLocation();

  return <ErrorContainer error={`Page not found: ${location.pathname}`} />;
};

export default NotFoundPage;
